module.exports = __webpack_public_path__ + "img/housebox-alt.e43adbcb.svg";